import { render, staticRenderFns } from "./PlayList.vue?vue&type=template&id=656f9572"
import script from "./PlayList.vue?vue&type=script&lang=js"
export * from "./PlayList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports